import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../../Providers/ModalContext';
import Modal from '../../../../Global/Modal';
import RichText from '../../../../Global/RichText';

import CloseIcon from '../../../../../Images/icons/close-icon.png';
import ArtistBg from '../../../../../Images/background/bg_ai-artists.png';
import LogoStudio from '../../../../../Images/logos/logo-studio.png';
import PlayImg from '../../../../../Images/gallery/ai-services/play.png';

import { Ai_Title } from '../../../../../utils/EN/Modals/aiArtists';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 60px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 4rem;
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;
  padding-right: 5%;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const AiArtistContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: ${({ $singleVideo }) =>
    $singleVideo ? 'flex-start' : 'space-between'};
  ${({ $singleVideo }) => ($singleVideo ? 'gap: 3rem;' : '')}

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
    align-items: center;
  }

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const AiArtist = styled.div`
  max-width: 367px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.313rem;
  padding-right: 20px;

  .mobile {
    display: none;
    text-transform: none;
    font-weight: 400;
    font-size: 0.75rem;

    @media (max-width: ${breakpoints.mobile}) {
      display: block;
    }
  }

  .desktop {
    display: block;

    @media (max-width: ${breakpoints.mobile}) {
      display: none;
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 100%;
    padding-right: 0;
  }
`;

const AiArtistTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.25rem;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: row;
  }

  p {
    text-transform: uppercase;
    text-align: center;
    padding: 10px;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 1.25rem;
    }
  }
`;

const AiArtistImg = styled.img`
  max-width: 271px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 172px;
  }
`;

const AiArtistGallery = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 10px 0;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

const AiArtistItem = styled.div`
  color: #fff;
  text-decoration: none;
  max-width: 348px;
  width: 100%;
  height: 786px;
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  flex-direction: column;
  background: #000;
  background-image: url(${({ $bgImage = '' }) => $bgImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
  cursor: pointer;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 100%;
    height: 165px;
    background-size: cover;
    background-position: center;
  }

  p {
    text-transform: uppercase;
    padding: 0 10px;
    color: #fff;
    text-decoration: none;
  }
`;

const AiArtistVideo = styled.img`
  width: 100%;
  height: auto;
  display: block;

  @media (max-width: ${breakpoints.mobile}) {
    width: 66px;
    margin: 0 auto;
  }
`;

const HorizontalVideoWrapper = styled.div`
  width: 100%;
  max-width: 1040px;
  display: flex;
  flex-direction: column;
  gap: 0.625rem;
  cursor: pointer;

  p {
    text-transform: uppercase;
    padding: 0 10px;
    margin: 0;
    color: #fff;
    text-decoration: none;
  }
`;

const HorizontalVideoBox = styled.div`
  position: relative;
  width: 100%;
  aspect-ratio: 1131 / 785;
  max-height: 480px;
  background: #000;
  background-image: url(${({ $bgImage = '' }) => $bgImage});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
`;

const HorizontalPlayButton = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 140px;
  height: auto;
  pointer-events: none;

  @media (max-width: ${breakpoints.mobile}) {
    width: 76px;
  }
`;

const ModalAiArtist = ({
  id,
  artistImage,
  artistName,
  artistTitle,
  artisText,
  videoRef1,
  videoRef2,
  videoRef3,
  videoRef4,
  videoRef5,
  videoBg1,
  videoBg2,
  videoBg3,
  videoBg4,
  videoBg5,
  videoText1,
  videoText2,
  videoText3,
  videoText4,
  videoText5,
  videoHorizontal1,
  videoHorizontal2,
  videoHorizontal3,
  videoHorizontal4,
  videoHorizontal5,
}) => {
  const { closeModal } = useModal();

  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  const videos = [
    { ref: videoRef1, bg: videoBg1, text: videoText1, horizontal: videoHorizontal1 },
    { ref: videoRef2, bg: videoBg2, text: videoText2, horizontal: videoHorizontal2 },
    { ref: videoRef3, bg: videoBg3, text: videoText3, horizontal: videoHorizontal3 },
    { ref: videoRef4, bg: videoBg4, text: videoText4, horizontal: videoHorizontal4 },
    { ref: videoRef5, bg: videoBg5, text: videoText5, horizontal: videoHorizontal5 },
  ].filter((video) => video.ref);

  const isSingleHorizontalVideo = videos.length === 1 && videos[0].horizontal;

  return (
    <>
      <Modal id={id} bgImg={ArtistBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={closeModal}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Ai_Title} />
          </TitleContent>

          <AiArtistContainer $singleVideo={isSingleHorizontalVideo}>
            <AiArtist>
              <AiArtistTitle>
                <AiArtistImg src={artistImage} alt={artistName} />
                <div>
                  <RichText dataText={artistTitle} />
                  <RichText className="mobile" dataText={artisText} />
                </div>
              </AiArtistTitle>
              <RichText className="desktop" dataText={artisText} />
            </AiArtist>
            {videos.length > 0 &&
              (isSingleHorizontalVideo ? (
                <HorizontalVideoWrapper
                  onClick={handleClick}
                  data-target={videos[0].ref}
                >
                  <HorizontalVideoBox $bgImage={videos[0].bg}>
                    <HorizontalPlayButton src={PlayImg} alt="Video 1" />
                  </HorizontalVideoBox>
                  <RichText dataText={videos[0].text} />
                </HorizontalVideoWrapper>
              ) : (
                <AiArtistGallery>
                  {videos.map((video, index) => (
                    <AiArtistItem
                      key={video.ref}
                      onClick={handleClick}
                      data-target={video.ref}
                      $bgImage={video.bg}
                    >
                      <AiArtistVideo src={PlayImg} alt={`Video ${index + 1}`} />
                      <RichText dataText={video.text} />
                    </AiArtistItem>
                  ))}
                </AiArtistGallery>
              ))}
          </AiArtistContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalAiArtist;
